import { loginSystem, logout } from '@/api/user';
import { getToken, setToken } from '@/util/token';
import { Base64 } from 'js-base64';

const userStore = {
  state: {
    user: {},
    token: getToken(),
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER: (state, user) => {
      state.user = {
        userName: Base64.encode(user.userName || ''),
        loginName: Base64.encode(user.loginName || ''),
        email: Base64.encode(user.email || ''),
        mobile: Base64.encode(user.mobile || ''),
        wechatOpenId: Base64.encode(user.wechatOpenId || ''),
      };
    },
  },

  actions: {

    // login
    doLogin({ commit }, user) {
      const loginParams = {
        loginName: user.userName,
        loginPassword: user.password,
        captcha: user.captcha,
      };
      return new Promise((resolve, reject) => {
        loginSystem(loginParams).then((response) => {
          if (response.code === 0) {
            commit('SET_USER', {
              userName: response.data.userName,
              loginName: response.data.loginName,
              email: response.data.email || '',
              mobile: response.data.mobile || '',
              wechatOpenId: response.data.wechatOpenId || '',
            });
            setToken(response.token);
          }
          resolve(response);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // logout
    doLogout({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_USER', {});
          // removeToken();
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // timeout logout
    doTimeoutLogout({ commit }) {
      return new Promise((resolve) => {
        commit('SET_USER', {});
        // removeToken();
        resolve();
      });
    },
  },
};

export default userStore;



// WEBPACK FOOTER //
// ./src/store/modules/user.js